<template>
  <div id="app">
    <router-view />
    <!-- <router-view :key="$route.fullPath" /> -->
  </div>
</template>

<script>
export default {
  mounted() {},
  methods: {},
};
</script>
<style lang="scss">
html,
body {
  height: 100%;
}
body {
  background-color: #fff;
}
@font-face {
  font-family: "SNEmericWeb_Book"; /* 自定义字体名称 */
  src: url("~@/assets/font/SNEmericWeb_Book.woff2") format("woff2"); /* 字体文件路径 */
  font-weight: 400;
  font-display: swap;
}
@font-face {
  font-family: "SNEmericWeb_SemiBold";
  font-weight: 600;
  src: url("~@/assets/font/SNEmericWeb_SemiBold.woff2") format("woff2");
  font-display: swap;
}
#app {
  // min-height: 100%;
  // height: 100%;
  // overflow: auto;
  // font-family: Arial, 'Source Han Sans CN', "Noto Sans CJK SC", "Source Han Sans CN", 'Microsoft YaHei', 'Source Han Serif SC', 'PingFangSC Regular', 'SimSun', 'Avenir', Helvetica, Arial, sans-serif;
  // -webkit-font-smoothing: antialiased;
  // -moz-osx-font-smoothing: grayscale;
  font-family: "SNEmericWeb_Book";
  color: #333;
}
p {
  margin: 0;
}
.van-cell:not(:last-child)::after {
  border-bottom-width: 1px !important;
}
.van-toast {
  z-index: 2100 !important;
}
</style>
